<template>
  <a
    target="_blank"
    class="pega-input"
    :href="`${bossCUrl}/help/guide/index_283.html`"
    data-test="provision-list-link"
  >登録情報規定一覧</a>
</template>

<script>
const BOSS_C_URL = process.env.BOSS_C_ENDPOINT

export default {
  computed: {
    bossCUrl: () => BOSS_C_URL // BOSS-Sからアクセスがある箇所はドメインから指定する必要があるため追加
  }
}
</script>
